import instance from "@/api/api_instance";

export const responseFriend = (id: number, accept: boolean) => {
  return instance.post(`friend/request/response`, {
    id: id,
    accept: accept,
  });
};

export const cancelFriendRequest = (id: number) => {
  return instance.post(`friend/request/cancel`, { id });
};

export const addFriend = (id: number) => {
  return instance.post(`friend/request`, { recipientId: id });
};

export const getFriendSuggestions = ({
  keyword,
  pageSize,
  pageNumber,
}: {
  keyword?: string;
  pageSize: number;
  pageNumber: number;
}): Promise<any> => {
  return instance.get("friend/suggestions", {
    params: {
      keyword,
      pageNumber,
      pageSize,
    },
  });
};

export const getFriendRequests = () => {
  return instance.get("friend/requests");
};

export const getFriendList = () => {
  return instance.get("friend/me");
};

export const unfriend = (id: number) => {
  return instance.delete(`friend/delete/`, {
    data: { recipientId: id },
  });
};
export const getUserProfile = (id: number) => {
  return instance.get(`user/profile-detail/${id}`);
};
